import { parsePhoneNumber } from "libphonenumber-js";

export const formatDisplayPhoneNumber = (phoneNumber: string) => {
  try {
    const parsed = parsePhoneNumber(phoneNumber, "CZ");
    return parsed.formatInternational();
  } catch {
    return phoneNumber;
  }
};
